export default "__VITE_ASSET__BEcZNKrE__"